<template>
  <div class="container">
    <Header></Header>
    <HeaderMobile></HeaderMobile>
    <div class="fp-container">
      <div class="fp-right">
        <div class="fp-right-overlay"></div>

        <AuthCardTwo
          head
          subhead="Don’t want to Authorize?"
          buttonText="Go Back"
          @clicked="goLogin"
        ></AuthCardTwo>
      </div>
      <div class="fp-left">
        <h1>Authorize New Location</h1>

        <div class="auth-input-section">
          <h5 class="heads">IP Address</h5>
          <input disabled :value="ipAddr" />
          <h5 class="heads">Auth Valid.</h5>
          <input disabled :value="tokenValid" />

          <ButtonFilled @onButtonClicked="handleAuthorize" :text="btnStatus"></ButtonFilled>
          <div class="error-message" v-html="errorMessage"></div>
          <div v-if="isSuccess" class="success-message">
            Password reset successful, you can
            <router-link to="/login">login</router-link>now.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- eslint-disable -->

<script>
import AuthHead from "../../../components/auth/AuthHead";
import AuthCardTwo from "../../../components/auth/AuthCardTwo";
import InputWidget from "../../../components/common/InputWidget";
import ButtonFilled from "../../../components/common/ButtonFilled";
import ThirdParty from "../../../components/auth/ThirdParty";
import CheckBox from "../../../components/common/Checkbox";
import ButtonOutlinedScroll from "../../../components/common/ButtonOutlinedScroll";
import Header from "../../../components/landing/Header";
import HeaderMobile from "../../../components/landing/HeaderMobile";
import {
  handleGetAuthIPParams,
  handleAuthorizeIP,
} from "../../../service/user";

export default {
  components: {
    AuthHead,
    AuthCardTwo,
    InputWidget,
    ButtonFilled,
    ThirdParty,
    CheckBox,
    ButtonOutlinedScroll,
    Header,
    HeaderMobile,
  },
  data() {
    return {
      ipAddr: "",
      tokenValid: "",
      headline: "",
      email: "",
      password: "",
      cPassword: "",
      btnStatus: "VERIFY",
      isSuccess: false,
      rememberMe: false,
      tok: "",
      errorMessage: "",
    };
  },

  async mounted() {
    window.scroll(0, 0);
    this.tok = window.location.href.split("?")[1];
    const response = await handleGetAuthIPParams(this.tok);
    this.tokenValid = response.data.data.valid.toString();
    this.ipAddr = response.data.data.ip;
    // console.log(response.data.data);
  },

  methods: {
    goLogin() {
      this.$router.push("login");
    },
    scrollDown() {
      window.scrollTo(0, document.body.scrollHeight);
    },

    async handleAuthorize() {
      this.errorMessage = "";
      this.btnStatus = "Wait..";
      try {
        await handleAuthorizeIP(this.tok);
        this.$router.push("login");
        this.btnStatus = "DONE";
      } catch (e) {
        this.errorMessage = e.message;
        this.btnStatus = "VERIFY"
      }
    },
  },
};
</script>

<style scoped>
.container {
  margin: auto;
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 10px;
  width: 95%;
  height: 1000px;
  margin: auto;
  margin-top: 14px;
  margin-bottom: 14px;
}

input {
  width: 297px;
  border: none;
  border-radius: 10px;
  background-color: #131517;
  height: 45px;
  padding: 0px 16px;
  color: #fff;
  margin: auto;
  margin-bottom: 16px;
  box-shadow: 0px 2px 4px #000000;
  text-align: center;
}

input:focus {
  outline: none;
}

.heads {
  text-align: start;
  margin-bottom: 8px;
  width: 100%;
  margin-left: 24px;
}

.auth-head {
  margin-top: 25px !important;
}

.fp-container {
  background-color: #1a1c1f;
  border-radius: 7px;
  width: 976px;
  box-shadow: 2px 2px 5px #0000002a;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: radial-gradient(
    ellipse 180% 170% at top,
    #26292e 0.4%,
    #1a1c1f 100%
  );
  transition: 0.3s;
}

.fp-left {
  flex: 0.6;
  max-width: 60%;
  height: 568px;
  display: flex;
  align-items: center;
  flex-direction: column;
  transition: 0.3s;
  justify-content: center;
}

.fp-left > h1 {
  color: #e0e0e0;
  margin-bottom: 24px;
  text-align: center;
}

.fp-left > h5 {
  font-size: 12px;
  line-height: 16px;
  color: #888888;
  margin-bottom: 32px;
  text-align: center;
}

.button-filled {
  margin-top: 32px !important;
}

.fp-right {
  position: relative;
  flex: 0.4;
  max-width: 40%;
  height: 568px;

  display: flex;
  justify-content: center;
  align-items: center;
  background-image: radial-gradient(
    ellipse 300% 150% at right bottom,
    #26292e 0.04%,
    #1a1c1f 100%
  );
  border-bottom-left-radius: 25px;
  border-top-left-radius: 25px;
  transition: 0.3s;
}

.fp-right-overlay {
  position: absolute;
  background: url("../../../assets/img/dom-labs.svg");
  background-repeat: no-repeat;
  background-size: auto;
  height: 100%;
  width: 100%;
}

.login-reset-password,
.keep-me-logged-in > p {
  color: #888888;
  font-size: 12px;
  margin-top: 16px;
  text-align: center;
}

.keep-me-logged-in {
  margin-bottom: 18px;
  margin-top: 6px;
}

.auth-input-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 60%;
}

.input-widget {
  margin-top: 0px !important;
  width: 80% !important;
}

@media only screen and (max-width: 786px) {
  #headerWeb {
    display: none !important;
  }
  #landingHeaderMobile {
    display: block !important;
  }
}

@media only screen and (max-width: 750px) {
  .fp-left,
  .fp-right {
    flex: 50% !important;
    max-width: 50% !important;
    width: 50%;
  }

  .auth-input-section {
    width: 90% !important;
  }

  input {
    width: 230px;
  }

  .fp-container {
    flex-wrap: wrap !important;
  }
}

@media only screen and (max-width: 610px) {
  .container {
    height: 100% !important;
  }
  .fp-left,
  .fp-right {
    flex: 100% !important;
    max-width: 100% !important;
    width: 100%;
  }

  .fp-right {
    border-radius: 0 !important;
    border-bottom-right-radius: 25px !important;
    border-bottom-left-radius: 25px !important;
    order: 1;
  }

  input {
    width: 230px;
  }

  .fp-container {
    flex-wrap: wrap !important;
  }

  .fp-left {
    height: 95vh;
    justify-content: center;
  }

  #fpHidden {
    display: flex !important;
    margin-top: 200px !important;
  }
}
</style>